var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.enabled)?_c('div',{staticClass:"pdp-btn round shopping-list-btn",class:`${_vm.isInList? 'in-list':''}`,on:{"click":_vm.handleClick}},[(_vm.isInList)?_c('p',[_vm._v(" "+_vm._s(_vm.lang.pdpRaddarRemoveFromList))]):_c('p',[_vm._v(" "+_vm._s(_vm.lang.pdpRaddarAddToList))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }